import React from 'react';
import PropTypes from 'prop-types';
import css from './ToggleButton.css';
import Icon from 'SF/MaterialIcon';

export default class ToggleButton extends React.Component {

  get iconName() {
    return this.props.isExpanded ? 'remove_circle_outline' : 'add_circle';
  }

  get class() {
    return `${css['toggle-row-button']} ${this.props.isMobile ? null : css['position']}`;
  }

  render() {
    return (
      <div 
        className={this.class}
        onClick={this.props.onClick}
        aria-label="Toggle comments"
        role="button"
        aria-expanded={this.props.isExpanded || false}
        tabIndex="0">
        <Icon icon={this.iconName} />
      </div>
    );
  }
}

ToggleButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  isExpanded: PropTypes.bool,
  isMobile: PropTypes.bool.isRequired
}
